import { Flex } from '@chakra-ui/react';
import { useCampaignUI } from './ui';
export function FilterBar({ children, trailing, px = 4, py = 4, ...props }) {
 const ui = useCampaignUI();
 return <Flex px={px} py={py} gap={3} align='center' wrap='wrap' borderBottom='1px solid' borderColor={ui.borderSubtle} {...props}>
  {children}{trailing && <Flex gap={2} ml={{ base: 0, md: 'auto' }} wrap='wrap'>{trailing}</Flex>}
 </Flex>;
}
